import { ReactNode } from 'react';
import {
  IconButton,
  IconButtonProps,
  makeStyles,
  Typography,
} from '@material-ui/core';

const useStyles = makeStyles(theme => ({
  iconWrapper: {
    display: 'flex',
    alignItems: 'center',
    borderLeft: `1px solid ${theme.palette.grey[200]}`,
    borderBottom: `1px solid ${theme.palette.grey[200]}`,
    borderTop: 0,
    borderRight: 0,
    backgroundColor: theme.palette.white,
    paddingInline: theme.spacing(1.5),
    height: '100%',
    borderRadius: 0,
    boxShadow: `0px 4px 16px 0px ${theme.palette.grey[200]}`,
  },
  label: {
    fontSize: '0.85rem',
    fontWeight: 600,
    color: theme.palette.primary.main,
    whiteSpace: 'nowrap',
    marginLeft: theme.spacing(1),
  },
}));

export type WbHeaderActionButtonProps = Omit<IconButtonProps, 'children'> & {
  icon: ReactNode;
  label?: string;
};

export const WbHeaderActionButton = ({
  icon,
  label,
  className,
  ...props
}: WbHeaderActionButtonProps) => {
  const classes = useStyles();
  return (
    <IconButton
      size="small"
      className={`${classes.iconWrapper}${className ? ` ${className}` : ''}`}
      {...props}
    >
      {icon}
      {label && <Typography className={classes.label}>{label}</Typography>}
    </IconButton>
  );
};
